import React from "react";
import Wrapper from "./toolTipIcon.styles";
import { FairGoTooltip } from "./fairGoTooltip";
import { useRandomId } from "@hooks/useRandomId";

export default function ToolTipIcon({ ...props }) {
  const {toolTipText} = props;
  
  // cannot find a way to remove ID's from this SVG, but we shouldn't have multiple elements with same id attribute,
  // so I have implemented this as a bodge
  const firstId = useRandomId();
  const secondId = useRandomId();
  
  return (
    <Wrapper>
      <FairGoTooltip title={toolTipText} disableFocusListener enterTouchDelay={0} leaveTouchDelay={30000} placement="top">
        <div className="toolTip-Icon">
          <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
            <defs xmlns="http://www.w3.org/2000/svg">
              <path id={firstId} d="M8 1.333C4.32 1.333 1.333 4.32 1.333 8c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667 0-3.68-2.987-6.667-6.667-6.667zm0 10c-.367 0-.667-.3-.667-.666V8c0-.367.3-.667.667-.667.367 0 .667.3.667.667v2.667c0 .366-.3.666-.667.666zM8.667 6H7.333V4.667h1.334V6z"/>
            </defs>
            <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
              <mask id={secondId} fill="#fff">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${firstId}`}/>
              </mask>
              <g className="circle" fill="#94C840" mask={`url(#${secondId})`}>
                <path d="M0 0H16V16H0z"/>
              </g>
            </g>
          </svg>
        </div>
      </FairGoTooltip>
    </Wrapper>
  );
}
